import React, { ComponentProps } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { capitalise } from 'lib/string/stringUtils'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { getFromDurationLabel } from 'selectors/offerPageSelectors'

interface Props extends ComponentProps<typeof BodyText> {
  durationLabel: string;
}

function OfferFromDurationLabel(props: Props) {
  const { durationLabel, ...rest } = props

  return (
    <BodyText {...rest}>
      {capitalise(durationLabel.toLowerCase())}
    </BodyText>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  durationLabel: getFromDurationLabel(state, appState),
}))(OfferFromDurationLabel)
